<template>
  <div class="create-report">
    <div class="create-report__title">Create New Export</div>
    <label class="create-report__input">
      <span class="create-report__label">Category</span>
      <div class="create-report__link-wrapper" :class="{'create-report__link-wrapper_single': isDomainDropdownHidden}">
          <base-select
            border-less="true"
            class="create-report__active"
            :class="{'form-control_error': externalErrors.fk_category_id_type}"
            :options="opts.category_types"
            v-model="report.fk_category_id_type"
            alignLeft="true"
            :max-height-list="450"
            :titleStyle="titleStyle"
            :headerStyle="selectTypeStyle"
          />
          <span class="create-report__error-message" v-if="externalErrors.fk_category_id_type">{{externalErrors.fk_category_id_type}}</span>
      </div>
    </label>
    <div class="create-report__date-picker-row" v-if="report.fk_category_id_type !== 117">
      <div class="create-report__date-wrapper">
        <base-date-picker-button name="start-date"
                                 :dates="dates"
                                 class="create-report__date"
                                 :class="{'create-report__date_error': externalErrors.start_date}"
                                 v-model="report.start_date"
                                 :maxDate="report.end_date">
          <div class="create-report__date-title">Start Date</div>
        </base-date-picker-button>
        <span class="create-report__error-message" v-if="externalErrors.start_date">{{externalErrors.start_date}}</span>
      </div>
      <div class="create-report__date-wrapper">
        <base-date-picker-button name="end-date"
                                 :dates="dates"
                                 class="create-report__date"
                                 :class="{'create-report__date_error': externalErrors.end_date}"
                                 v-model="report.end_date"
                                 :minDate="report.start_date">
          <div class="create-report__date-title">End Date</div>
        </base-date-picker-button>
        <span class="create-report__error-message" v-if="externalErrors.end_date">{{externalErrors.end_date}}</span>
      </div>
    </div>
    <div class="create-report__controls">
      <button class="create-report__button create-report__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button class="create-report__button create-report__button_submit"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}

/**
 * Popup is shown when we want to add new URL
 */
export default {
  name: 'CreateReportPopup',
  mixins: [BaseModalMixins],
  props: {
    opts: {
      type: Object,
      required: true
    },
    dates: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      report: {
        fk_category_id_type: -1,
        start_date: null,
        end_date: null
      },
      externalErrors: {
        fk_category_id_type: null,
        start_date: null,
        end_date: null
      },
      isValidating: false,
      isDomainDropdownHidden: true,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      },
      selectTypeStyle: _.cloneDeep(SELECT_STYLE)
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    apply () {
      this.$emit('apply', this.report)
    }
  }
}
</script>

<style lang="scss">
  .create-report {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 30px;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }

    &__date-wrapper {
      display: flex;
      font-weight: bold;
      flex-direction: column;
      flex: 0 0 30%;
    }

    &__date-picker-row {
      display: flex;
    }

    &__date {
      color: $rfx-dark-march;

      &_error {
        color: $rfx-red;
      }
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_delete {
          background-color: $rfx-red;
          color: #fff
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }
    &__link {
      &-wrapper {
        position: relative;
        margin-top: 30px;

        &_single{
          margin-top: 0;
        }
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

    &__error-message {
        color: $rfx-red;
        font-size: 10px;
        margin-top: 5px;
      }

  }

  .form-control {
    height: 50px;
    padding: 0 20px;
    border: 2px solid $rfx-light-steel;
    outline: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: $rfx-dark-march;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error{
       border-color: $rfx-red;
      color: $rfx-red;

       &::placeholder {
         color: $rfx-red;
         font-size: 13px;
       }

     }
  }

</style>
